import { AuthState } from '@okta/okta-auth-js';

import { PositionsOptionMonthsMassUpdates } from '../../services/backend/PositionsOptionMonthsMassUpdates';
import { useBaseApiClient } from '../useBaseApiClient';

export const usePositionsOptionMonthsMassUpdates: () => PositionsOptionMonthsMassUpdates<AuthState> =
  () => {
    return useBaseApiClient(PositionsOptionMonthsMassUpdates);
  };
